import { store } from '@/app/store'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'

export class ReportedPostsRtkDatasource {
  async list(page = 0, limit = 50) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getReportedPosts.initiate({ page, limit })
    )
    if (result.error) throw result.error
    return result.data ?? []
  }

  async hideReportedPost(reportId: string) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.hideReportedPost.initiate(reportId)
    )
    if (result.error) throw result.error
  }
}
